import { EducationReminderCheckbox } from "../models";

export const reminders: EducationReminderCheckbox[] = [
  { id: "1-day", value: 1, label: "1 dan prije početka" },
  { id: "2-day", value: 2, label: "2 dana prije početka" },
  { id: "3-day", value: 3, label: "3 dana prije početka" },
  { id: "4-day", value: 10, label: "10 dana prije početka" },
];
